const concatIdName = (id, name) => {
  const handledId = id !== undefined ? "#" + id : "";
  return handledId + " " + name;
};

export default concatIdName;